import { format } from 'date-fns';

import {
  type StoreBlackout,
  type StoreOpenAppointment,
  type TimeSlot as UbifTimeSlot,
} from '@service-initiation/shared-clients-tech-care-services';

import { type AppointmentDate } from '../types/AppointmentDate';
import { type TimeSlot } from '../types/TimeSlot';

const isDateAvailable = (dateString: string, blackoutDays: StoreBlackout[]) => {
  const date = new Date(dateString);
  const dayOfYear = parseInt(
    format(date, 'D', { useAdditionalDayOfYearTokens: true })
  );
  const year = parseInt(format(date, 'yyyy'));
  if (
    blackoutDays.length > 0 &&
    blackoutDays.find(
      (blackoutDay) =>
        blackoutDay.day_of_year === dayOfYear && blackoutDay.year === year
    )
  ) {
    return false;
  }
  return true;
};

const convertTimeSlotResponse = (timeSlot: UbifTimeSlot): TimeSlot => ({
  end: timeSlot.end,
  start: timeSlot.start,
  value: timeSlot.appointment_at_utc,
});

const getAvailableAppointmentTimes = (openAppointment: StoreOpenAppointment) =>
  openAppointment.at
    .filter((a) => a.slots > 0)
    .map((t) => convertTimeSlotResponse(t));

export const ubifAppointmentToTechCareAppointment = (
  openAppointment: StoreOpenAppointment,
  blackoutDaysRes: StoreBlackout[]
): AppointmentDate => {
  const { date } = openAppointment;
  const formattedDate = date.replace(/-/g, '/');

  return {
    availableTimes: getAvailableAppointmentTimes(openAppointment),
    date: formattedDate,
    isDisabled: !isDateAvailable(formattedDate, blackoutDaysRes),
  };
};
